import React from 'react';

import styles from './styles.scss';
import {Link} from 'react-router-dom';
import logo from '../../../assets/media/logo.png';
import {Agreement} from '../../utils/agreement';
//import {Social} from '../../utils/social';

import {views} from '../../../constants/views';

import classnames from 'classnames';


//<Link to='/' className={styles.footerLink}>
//    <img src={logo} alt='logo' className={styles.logoImg}/>
//    Boosters.pro
//</Link>


import styles_social from '../../utils/social/styles.scss';

import vk from '../../../assets/media/vk_grey_big.png';
import vk_color from '../../../assets/media/vk_color_big.png';
import telegram from '../../../assets/media/telegram_grey_big.png';
import telegram_color from '../../../assets/media/telegram_color_big.png';
import facebook from '../../../assets/media/facebook_grey_big.png';
import facebook_color from '../../../assets/media/facebook_color_big.png';

export const Social = () => (
    <div className={classnames(styles_social.socialNetworks, styles.socialNetworks)}>
        <a href='https://vk.com/boosters_official' target='_blank' rel='noopener noreferrer'>
            <img src={vk} alt='vk_image' className={styles_social.socialNetworksImg}
                 onMouseOver={e => (e.currentTarget.src = vk_color)}
                 onMouseOut={e => (e.currentTarget.src = vk)}
            style={{width: '24px'}}/>
        </a>

        <a href='https://t.me/boosters' target='_blank' rel='noopener noreferrer'>
            <img src={telegram} alt='telegram_image' className={styles_social.socialNetworksImg}
                 onMouseOver={e => (e.currentTarget.src = telegram_color)}
                 onMouseOut={e => (e.currentTarget.src = telegram)}
                 style={{width: '24px'}}/>
        </a>
        {/*<a href={'https://www.facebook.com/boostersrussia/'} target='_blank' rel='noopener noreferrer'>
        <img src={facebook} alt='facebook_image' className={styles_social.socialNetworksImg}
             onMouseOver={e => (e.currentTarget.src = facebook_color)}
             onMouseOut={e => (e.currentTarget.src = facebook)}
             style={{width: '24px', cursor: 'pointer', marginTop: '-3px', marginRight: '0'}}/>
        </a>*/}
    </div>
);

//<div className={styles.footer} style={page !== views.ABOUT_PAGE ? {border: 'none'} : {}}>
export const Footer = ({page}) => (
    <div className={styles.footer}>
    <Agreement/>
        <div className={styles.footerSocial}>
            <Social/>
        </div>
    </div>
);

export const FooterSmall = () => (
    <div className={styles.footerSmall}>
        <Agreement/>
        <Social/>
    </div>
);



// WEBPACK FOOTER //
// src/components/forumFullPage/forumFooter/index.jsx